/* eslint-disable react/prop-types */
import _ from 'lodash';
import React from 'react';
import Grid from '@mui/material/Grid';
import { SDK_TYPES, PLATFORM_TYPES } from 'relevant-shared/prebid/strictImpressionCounting';
import ExternalSystemEdit from '../components/ExternalSystemEdit';
import ExpandSelector from '../components/ExpandSelector';
import FieldArray from '../components/FieldArray';
import Select from '../components/Select';
import Switch from '../components/Switch';
import { Banner } from '../components/Banner';
import classes from '../api/classes';
import Disabler from '../components/Disabler';

const { StrictImpressionCountingCondition } = classes;

const renderCondition = (field) => {
	const selectFor = (name, label, opts) => (
		<Grid item xs={12} sm={6}>
			<Select
				fullWidth
				label={label}
				items={opts}
				{...field(name)}
			/>
		</Grid>
	);
	return (
		<Grid container spacing={2}>
			{selectFor('sdkType', 'SDK Type', SDK_TYPES)}
			{selectFor('platformType', 'Platform Type', PLATFORM_TYPES)}
		</Grid>
	);
};

function Renderer({ field, form, model, parent }) {
	const { overrideDefaultSettings: isOverriding } = model;
	const { defaultStrictImpressionCountingSettings: defaults } = parent;
	const current = isOverriding ? { model, field } : {
		model: defaults,
		field: (name) => ({ name, value: _.get(defaults, name) }),
	};
	const { conditions } = current.model;
	const handleOverrideChange = (value) => {
		if (value && model.conditions.length === 0) {
			model.conditions = defaults.conditions.map((cond) => new StrictImpressionCountingCondition(cond));
		}
	};
	return (
		<ExpandSelector
			title="Strict impression counting for APPs"
			selected={conditions}
			form={form}
		>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Switch
						{...field('overrideDefaultSettings')}
						label="Override defaults"
						preReaction={handleOverrideChange}
					/>
				</Grid>
				{!conditions.length && (
					<Grid item xs={12}>
						<Banner
							message={<>Strict impression counting is <i>disabled</i> as no conditions are added</>}
						/>
					</Grid>
				)}
				<Grid item xs={12}>
					<Disabler disabled={!isOverriding}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<FieldArray
									model={current.model}
									field={current.field}
									name="conditions"
									update={() => form.update()}
									createNew={() => new StrictImpressionCountingCondition()}
									render={renderCondition}
									renderContainer={(content, after) => (
										<div style={{ display: 'grid', gridTemplateColumns: '1fr 150px' }}>
											{content}
											{after}
										</div>
									)}
								/>
							</Grid>
						</Grid>
					</Disabler>
				</Grid>
			</Grid>
		</ExpandSelector>
	);
}

ExternalSystemEdit.registerCustomRenderer('StrictImpressionCountingSettings', Renderer);
